export const formFieldsConfig = {
  name: {
    name: 'name',
    label: 'Give the risk product a name',
    type: 'text',
  },
  value: {
    name: 'value',
    label: 'Policy value',
    type: 'number',
  },
  monthly_contribution: {
    name: 'monthly_contribution',
    label: 'Monthly contribution',
    subLabel: `The monthly contribution is for record purposes only and do not form part of the budget expenses.
               You can add them as expenses in the budget section.`,
    type: 'number',
  },
  contract_number: {
    name: 'contract_number',
    label: 'Contract/Policy number',
    // subLabel: "The contract number cannot be changed once the asset starts receiving data.",
    type: 'text',
  },
  service_provider_id: {
    name: 'service_provider_id',
    label: 'Service provider',
    // subLabel: "The service provider cannot be changed once the asset starts receiving data.",
    type: 'select',
  },
  owners: {
    name: 'owners',
    label: 'Owner(s)',
    type: 'tags',
  },
  payers: {
    name: 'payers',
    label: 'Payer(s)',
    type: 'tags',
  },
  beneficiaries: {
    name: 'beneficiaries',
    label: 'Beneficiaries',
    type: 'tags',
  },
}

export const formFieldsForRiskProductType = () => {
  const sharedFields = [
    formFieldsConfig.name,
    formFieldsConfig.value,
    formFieldsConfig.monthly_contribution,
    formFieldsConfig.contract_number,
    formFieldsConfig.service_provider_id,
    formFieldsConfig.owners,
    formFieldsConfig.payers,
    formFieldsConfig.beneficiaries,
  ]

  return [...sharedFields]
}

